import { jsx as _jsx } from "react/jsx-runtime";
import { Heading } from "catalyst/heading";
const NotFound = () => _jsx(Heading, { children: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 :-(" });
export default NotFound;
